// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2ZnC0","content":"LoadingAlert_content__3fSGR"};